import React from 'react';
import { useQuoteStore } from '@/store/quoteStore';

const ProgressIndicator = () => {
  const { currentStep } = useQuoteStore();
  const totalSteps = 7;

  return (
    <div className="w-full" data-testid="progress-indicator">
      <div className="flex justify-between items-center mb-4">
        <span className="text-sm font-medium text-[#27292E]">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-[#2F5E96]">
          {Math.round((currentStep / totalSteps) * 100)}%
        </span>
      </div>
      
      <div className="flex gap-2">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={`progress-step-${index + 1}`}
            className={`h-2 flex-1 rounded-full transition-all duration-300 ${
              index < currentStep
                ? 'bg-[#2F5E96]'
                : 'bg-gray-200'
            }`}
            data-testid={`progress-step-${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;